<template>
  <div class="forbidTheSale">
    <!-- 表单搜索 start -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from"
      @Refresh="onHandleRefresh"
      @search="onSearch"
    >
      <template v-slot:left>
        <el-button type="primary" @click="additem">新增</el-button>
      </template>
    </Filtersearch>
    <!-- 表单搜索 end -->

    <div class="auto-table-flex tablewearo">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
        ref="table"
        style="width: 100%"
      >
        <el-table-column type="index" width="100px" align="center" label="序号">
        </el-table-column>
        <el-table-column label="供货商名称" align="center" prop="title">
        </el-table-column>
        <el-table-column
          label="集配中心"
          align="center"
          prop="logisticBusinessName"
        >
        </el-table-column>
        <el-table-column
          label="对接业务类型"
          align="center"
          prop="buyerCreatorTypeName"
        >
        </el-table-column>
        <el-table-column label="联系人" align="center" prop="fullname">
        </el-table-column>
        <el-table-column label="联系电话" align="center" prop="mobile">
        </el-table-column>
        <el-table-column label="对接业务" align="center" prop="buyerName">
        </el-table-column>
        <el-table-column
          label="禁售品类"
          align="center"
          width="300"
          prop="forbidTheSaleCategoryName"
        >
        <template slot-scope="scope">
            <div v-if="scope.row.forbidTheSaleCategoryName.length<=10">{{ scope.row.forbidTheSaleCategoryName }}</div>
            <el-button v-else type="text" @click="cofirmclcik(scope.row)">{{ scope.row.forbidTheSaleCategoryName.substring(0, 11) }}...</el-button>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="onHandleProhibited(scope.row)"
              >禁售品类</el-button
            >
            <el-button type="text" @click="remove(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="from.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <addforbidTheSale
      ref="addforbidTheSaleref"
      @onchange="onHandleRefresh"
    ></addforbidTheSale>
    <ProhibitedCategories
      ref="ProhibitedCategoriesref"
      @on-refresh-list="hqlist"
    ></ProhibitedCategories>
  </div>
</template>

<script>
import Filtersearch from "@/components/Filtersearch.vue";
import addforbidTheSale from "./modules/addforbidTheSale.vue";
import ProhibitedCategories from "./modules/ProhibitedCategories.vue";
export default {
  name: "Selected-products",
  components: { Filtersearch, addforbidTheSale, ProhibitedCategories },
  data() {
    return {
      total: 0,
      currentPage: 0,
      loading: false,
      tableData: [],
      Filtersearchlist: [],
      from: {
        page: 1,
        pageSize: 50,
      },
    };
  },
  watch: {},
  mounted() {
    this.hqlist();
  },
  methods: {
    cofirmclcik(e){
        this.$confirm(e.forbidTheSaleCategoryName, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          
        })
    },
    /**
     * 禁售品类
     */
    onHandleProhibited(row) {
      this.$refs.ProhibitedCategoriesref.onInitData(row);
    },
    additem(e) {
      this.$refs.addforbidTheSaleref.getinfo();
    },
    /**
     * 重置表单，并刷新
     */
    onHandleRefresh() {
      Object.assign(this.$data.from, this.$options.data().from);
      this.hqlist();
    },
    /**
     * 搜索表单
     */
    onSearch(e) {
      this.from = e;
      this.from.page = 1;
      this.hqlist();
    },
    remove(el) {
      this.$confirm(
        `移除后，该供货商所禁售的品类将得以解禁，可重新上架销售。`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      ).then(() => {
        this.$api.general
          .forbiddencategorydelete({ supplierId: el.id })
          .then((res) => {
            this.$message.success("移除禁售成功");
            this.hqlist();
          });
      });
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.currentPage = val;
      this.hqlist();
    },
    hqlist() {
      this.loading = true;
      this.$api.general.forbiddencategorylist(this.from).then((res) => {
        console.log(res);
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      });
    },
  },
  created() {},
};
</script>

<style lang="scss">
.el-message-box__message{
    max-height:600px ;
    overflow: auto;
}
.forbidTheSale {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
